import Client from './client';

export default class MarketingGatewayLocalizedItems extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postRandom(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/marketing/gateway/items/random`, {
      ...options,
       method: 'POST',
    });
  }

}
